import React from 'react'
import Style from './SendToBasket.module.css'
import Button from '../Button/Button'
import { useHistory } from 'react-router'
const SendToBasket = () => {
    const history=useHistory()
    const MoveToBasket=()=>{
        history.push('/shopping')
    }
    return (
        <div className={Style.BasketBtnHolder}>
            <Button Value={'سبد خرید'} ClassBtn={'confrimBtn'} ClickHandler={MoveToBasket}/>
        </div>
    )
}

export default SendToBasket
